<template>
    <section class="invoice-preview-wrapper">
        <b-row class="frame-row">
            <b-col
                cols="12"
                xl="9"
                md="8"
                id="frame-holder"
            >
                <iframe id="print-frame" :src="invoiceData.IframePublicUrl+`&lang=`+ quoteLocale" width="100%" height="1000px" frameborder="0"></iframe>
            </b-col>
            <!-- Right Col: Card -->
            <b-col
                cols="12"
                md="4"
                xl="3"
                class="invoice-actions"
            >
                <b-card>
                    <div v-if="getStatusTitle" class="status-holder pb-2 text-center">
                        <span class="status-title mr-05">
                            {{ i18nT(`Status`) }}:
                        </span>
                        <span
                            :class="statusBadgeClasses()">
                          {{ getStatusTitle }}
                      </span>
                        <div class="mt-2">
                            <div v-if="SentAt" class="font-small-3">
                                <strong>{{ i18nT(`Sent on`) }}: </strong><span>{{ SentAt | dateTime }}</span>
                            </div>
                            <div v-if="SentTo" class="font-small-3">
                                <strong>{{ i18nT(`Sent to`) }}: </strong><span>{{ SentTo }}</span>
                            </div>
                        </div>
                    </div>

                    <b-form-group
                        :label="i18nT(`Document language`)"
                    >
                        <b-form-select
                            v-model="quoteLocale"
                            :options="cultures"
                            :reduce="label => label.value"

                            ></b-form-select>
                    </b-form-group>

                    <!-- USE INTERNATIONAL _ DISABLED -->
                    <b-form-checkbox
                        v-model="useInternational"
                        switch
                        class="mb-2"
                        v-if="false"
                    >
                        {{i18nT(`Use international company data`)}}
                    </b-form-checkbox>


                    <!-- Button: Send Invoice -->
                    <b-button
                        v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                        v-b-toggle.sidebar-send-invoice
                        variant="primary"
                        class="mb-75"
                        block
                    >
                        <font-awesome-icon icon="paper-plane" class="mr-1" />
                        {{i18nT(`Send Quote`)}}

                    </b-button>

                    <!-- Button: Download -->
                    <b-button
                        v-ripple.400="'rgba(186, 191, 199, 0.15)'"
                        variant="outline-secondary"
                        class="mb-75"
                        block
                        @click="openDownload"
                        :disabled="!invoiceData.QuoteDownloadUrl"
                    >
                        <font-awesome-icon icon="download" class="mr-1" />
                        {{i18nT(`Download`)}}
                    </b-button>

                    <!-- Button: Print -->
                    <b-button
                        v-ripple.400="'rgba(186, 191, 199, 0.15)'"
                        variant="outline-secondary"
                        class="mb-75"
                        block
                        @click="onCreateInvoice"
                    >
                        <font-awesome-icon  :icon="['fas', 'file-invoice-dollar']" class="mr-1" />
                        {{i18nT(`Create invoice`)}}
                    </b-button>

                    <b-button
                        v-ripple.400="'rgba(186, 191, 199, 0.15)'"
                        variant="outline-secondary"
                        class="mb-75"
                        block
                        @click="showPublicLink"
                    >

                        <font-awesome-icon icon="link" class="mr-1" />
                        {{i18nT(`Open public link`)}}
                    </b-button>


                    <!-- Button: Edit -->
                    <b-button
                        v-ripple.400="'rgba(186, 191, 199, 0.15)'"
                        variant="outline-primary"
                        class="mb-75"
                        block
                        :to="{ name: 'quote-edit', params: { id: $route.params.id } }"
                    >
                        <font-awesome-icon icon="pen" class="" />
                        {{i18nT(`Edit`)}}
                    </b-button>

                </b-card>
            </b-col>

        </b-row>

        <quote-sidebar-send />
    </section>
</template>

<script>
//import router from '@/router'
import {
    BRow,
    BCol,
    BCard,
    BFormGroup,
    BFormSelect,
    BFormCheckbox,
    BButton,
    BAlert,
    BLink,
    VBToggle,
} from 'bootstrap-vue'

import Ripple from 'vue-ripple-directive'
import store from '@/store'
import QuoteSidebarSend from '@/views/accounting/Quotes/QuoteSidebarSend'
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
import {dictToSelectArray} from "@core/utils/utils";

export default {
    directives: {
        Ripple,
        'b-toggle': VBToggle,
    },
    components: {
        BRow,
        BCol,
        BCard,
        BButton,
        BFormGroup,
        BAlert,
        BLink,
        BFormSelect,
        BFormCheckbox,
        QuoteSidebarSend,
    },
    data() {
        return {
            invoiceDescription: [],
            selectedLocale: 'en',
            cultures: [],
            quoteLocale: 'en',
            useInternational: false,
        }
    },

    methods: {
        onCreateInvoice(){
			this.$router.push({name: 'create-quote-invoice', params: {quoteId: this.invoiceData.Id}});
            // let formData = new FormData();
            // formData.append('quote_id', this.invoiceData.Id);
			//
            // this.$http.post(`quotes/createInvoice`, formData).then((response) => {
            //     this.$toast({
            //         component: ToastificationContent,
            //         props: {
            //             title: this.i18nT(`Success`),
            //             icon: 'CheckIcon',
            //             variant: 'success',
            //             message: this.i18nT(`Invoice created successfully`)
            //         },
            //     });
            //     this.$router.push({name: 'edit-invoice', params: {id: response.data.data.Id}});
            // });
        },

        statusBadgeClasses() {
            let base_classes = 'badge badge-pill ';
            switch (this.invoiceData.Status) {
                case 'pending':
                    return base_classes + 'badge-light-warning';
                case 'accepted':
                    return base_classes + 'badge-light-success';
                case 'rejected':
                    return base_classes + 'badge-light-danger';
                default:
                    return base_classes + 'badge-light-secondary';
            }
        },
        printInvoice() {
            window.print()
        },
        openDownload() {
            window.open(this.invoiceData.QuoteDownloadUrl+"&lang="+this.quoteLocale, '_blank');
        },
        showPublicLink() {
            window.open('/quote/'+this.invoiceData.Id+'/h/'+this.invoiceData.Hash+"?lang="+this.quoteLocale, '_blank');
        }
    },
    created(){
        this.$http.get(`system/cultures`).then(({data}) => {
            this.cultures = dictToSelectArray(data.data)
        })
    },
    mounted() {
        let enumsReady = store.getters['invoices/getEnumsState'];

        if(enumsReady){
            store.dispatch('invoices/populateEnums');
        }

        store.dispatch('invoices/fetchQuoteDetails', this.$route.params.id);
    },
    computed: {
        getStatusTitle() {
            if (this.invoiceData && this.invoiceData.Status) {
                let status = this.invoiceData.Status;
                return this.i18nT(status.charAt(0).toUpperCase() + status.slice(1)).replace('_', ' ');
            } else {
                return null;
            }
        },
        SentAt() {
            if (this.invoiceData && this.invoiceData.SentAt) {
                return this.invoiceData.SentAt;
            } else {
                return null;
            }
        },
        SentTo() {
            if (this.invoiceData && this.invoiceData.SentTo) {
                return this.invoiceData.SentTo;
            } else {
                return null;
            }
        },
        invoiceEnums () {
            return store.getters['invoices/getInvoiceEnums'];
        },
        curInvoiceId(){
            return this.$route.params.id;
        },
        invoiceData(){
            return store.getters['invoices/getQuoteData'];
        }
    },
    watch: {
        invoiceData: {
            handler(val) {
                if(val && val.WorkspaceObj) {
                    this.quoteLocale = this.invoiceData.WorkspaceObj.Language;
                    if (!this.quoteLocale) {
                        this.quoteLocale = this.$i18n.locale;
                    }
                }
            },
            immediate: true
        },
        curInvoiceId (val, oldVal) {
            if(val && val !== oldVal)
                store.dispatch('invoices/fetchQuoteDetails', val);
        }
    }

}
</script>

<style lang="scss" scoped>
@import "~@core/scss/base/pages/app-invoice.scss";
</style>

<style lang="scss">
.status-holder {
    font-size: 14px;
    text-align: center;
}


@media print {

    // Global Styles
    body {
        background-color: transparent !important;
    }
    nav.header-navbar {
        display: none;
    }
    .main-menu {
        display: none;
    }
    .header-navbar-shadow {
        display: none !important;
    }
    .content.app-content {
        margin-left: 0;
        padding-top: 2rem !important;
    }
    footer.footer {
        display: none;
    }
    .card {
        background-color: transparent;
        box-shadow: none;
    }
    .customizer-toggle {
        display: none !important;
    }

    // Action Right Col
    .invoice-actions,
    .b-sidebar-outer,
    .footer,
    .crisp-client,
    .Vue-Toastification__container,
    .btn-scroll-to-top,
    .vertical-layout .card.suggestion-box,
    .vertical-layout .breadcrumb-wrapper,
    .content-overlay,
    .content-wrapper row:not(.frame-row){
        display: none !important;
    }

    #frame-holder {
        width: 100vw !important;
        min-width: 820px;
        display: flex;
        justify-content: center;
        align-items: center;
        vertical-align: top;
    }

    iframe#print-frame{
        width: 100% !important;
        min-width: 800px;
    }
}
</style>
